<template>
    <div class="page">
        <ion-grid class="page-content">
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row>
                        <ion-col size="12" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                New Password
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                class="form-input"
                                type="password"
                                autofocus="true"
                                placeholder="Min 8 Chars,1 Uppercase, 1 Spl Char"
                                id="newpassword"
                                @input="newpassword = $event.target.value"
                                maxlength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="12" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Confirm Password
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                class="form-input"
                                type="password"
                                placeholder="Min 8 Chars,1 Uppercase, 1 Spl Char"
                                @input="confirmpassword = $event.target.value"
                                maxlength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col text-right>
                    <ion-button class="btn-primary" expand="block" @click="resetPassword">Submit</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonSpinner } from "@ionic/vue";
import { AuthenticationService } from "../../service/account/authenticator.service";
import { LocalStorage } from "../../data/localstorage";
import { User } from "../../entity/authentication/user";
import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'resetPassword',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonSpinner
    },
    data() {
        return {
            loaderTab: false,
            newpassword: "",
            confirmpassword: ""
        }
    },
    mounted() {
        this.setFirstFocus();
    },
    methods: {
        setFirstFocus() {
            document.getElementById("newpassword").setFocus();
        },
        async resetPassword() {
            try {
                if (
                typeof this.newpassword === "undefined" ||
                this.newpassword === null ||
                this.newpassword === "" ||
                this.newpassword.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter New password");
                } else if (new ValidationUtils().password(this.newpassword) === false) {
                    new ToastUtils().presentToast(
                    "Password must be 8 characters with atleast 1 Upper Case and 1 Special Character"
                );
                } else if (
                typeof this.confirmpassword === "undefined" ||
                this.confirmpassword === null ||
                this.confirmpassword === "" ||
                this.confirmpassword.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Confirm password");
                } else if (this.newpassword === this.confirmpassword) {
                    this.loaderTab = true;
                    await new AuthenticationService().resetPasswordForUserWithOTP(
                        this.newpassword,
                        new LocalStorage().user,
                        new LocalStorage().otp
                    );
                    window.localStorage.clear();
                    new ToastUtils().presentToast("Password reset successfully");
                    this.loaderTab = false;
                    this.$router.push("/login");
                } else {
                    new ToastUtils().presentToast("Confirm password is not matching");
                }
            } catch (error) {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
                this.loaderTab = false;
            }
        }
    }
})
</script>